import ApiService from '../../../../../services/ApiService'

export default {
  props: {
    title: String,
    metricRange: Object,
    metric: Object,
  },

  created() {
    this.currentMetricRange.calibrationPatternMetricId = this.metric.id

    if (this.metricRange) {
      this.currentMetricRange = this.metricRange
      this.isEditing = true
    }
  },

  data: () => ({
    step: 0,
    errorMessage: '',
    loading: false,
    firstValid: true,
    alterDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    currentMetricRange: {
      id: 0,
      range: null,
      k: null,
      uncertainty: null,
      tendency: null,
      calibrationPatternMetricId: null,
    },
    rangeRules: [(v) => !!v || 'Faixa é requerida'],
    kRules: [(v) => !!v || 'K é requerido'],
    uncertaintyRules: [(v) => !!v || 'Incerteza é requerida'],
    tendencyRules: [(v) => !!v || 'Tendência é requerida'],
    apiService: new ApiService(),
  }),

  computed: {
    currentTitle() {
      switch (this.step) {
        case 0:
          return 'Dados gerais'
        default:
          return this.isEditing ? 'Atualização efetuada' : 'Cadastro efetuado'
      }
    },

    buttonText() {
      switch (this.step) {
        case 0:
          return this.isEditing ? 'Atualizar' : 'Adicionar'
        default:
          return 'Terminar'
      }
    },
  },

  methods: {
    close() {
      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$emit('close')
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    async next() {
      if (this.step === 0) {
        if (this.$refs.firstForm.validate()) {
          this.submit()
        }
      } else {
        this.closeDialog()
      }
    },

    async submit() {
      this.loading = true

      const calibrationPatternMetricRange = {
        Id: this.currentMetricRange.id,
        Range: this.currentMetricRange.range,
        K: this.currentMetricRange.k,
        Uncertainty: this.currentMetricRange.uncertainty,
        Tendency: this.currentMetricRange.tendency,
        CalibrationPatternMetricsId:
          this.currentMetricRange.calibrationPatternMetricId,
      }

      let url = 'calibrationPatternMetricsRange/add'

      if (this.isEditing) {
        url = 'calibrationPatternMetricsRange/edit'
      }

      await this.apiService
        .post(url, calibrationPatternMetricRange)
        .then(() => {
          this.step++
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          setTimeout(() => {
            this.error = false
          }, 4000)
        })

      this.loading = false
      this.changedData = false
    },
  },

  watch: {
    currentMetricRange: {
      deep: true,
      handler() {
        if (this.isEditing) {
          this.changedData = true
        }
      },
    },
  },
}
